export default {
  menu: [],
  user: {},
  totalLogs: 0,
  totalVencidos: 0,
  Logs: []
}
